import API from './jsonapi-constants'

export const CONSTANTS = {
  TYPE: 'backorder',
  ATTRIBUTE: {
    ARTICLE_NAME: 'articleName',
    ARTICLE_NUMBER: 'articleNumber',
    DELIVERED_QUANTITY: 'deliveredQuantity',
    EXPECTED_DELIVERY_DATE: 'expectedDeliveryDate',
    ORDER_DATE: 'orderDate',
    ORDER_NUMBER: 'orderNumber',
    ORDER_QUANTITY: 'orderQuantity',
    POSITION: 'position',
    QUANTITY_CONFIRMED: 'quantityConfirmed',
  },
}

export const PATHS = {
  ARTICLE_NAME: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ARTICLE_NAME],
  ARTICLE_NUMBER: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ARTICLE_NUMBER],
  DELIVERED_QUANTITY: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.DELIVERED_QUANTITY],
  EXPECTED_DELIVERY_DATE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.EXPECTED_DELIVERY_DATE],
  ORDER_DATE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ORDER_DATE],
  ORDER_NUMBER: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ORDER_NUMBER],
  ORDER_QUANTITY: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ORDER_QUANTITY],
  POSITION: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.POSITION],
  QUANTITY_CONFIRMED: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.QUANTITY_CONFIRMED],
}

export default {
  ...CONSTANTS,
  PATHS,
}
